/* 🤖 this file was generated by svg-to-ts */
export const DfIconBell16: {
  name: 'bell-16';
  data: string;
} = {
  name: 'bell-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.495 1.177A.682.682 0 0 1 6.472 1c0-.552.671-1 1.5-1 .828 0 1.5.448 1.5 1 0 .06-.008.12-.024.177C11.851 1.8 13.192 4.075 13.472 8c1.003.667 1.504 1.5 1.504 2.5 0 1.5-4.937 1.503-7.003 1.503S1 12 1 10.563c0-.956.49-1.81 1.472-2.563.281-3.924 1.622-6.198 4.023-6.823zm-1.02 12.734a33.836 33.836 0 0 0 4.994 0l.003.089c0 1.105-1.396 2-2.5 2-1.105 0-2.5-.895-2.5-2 0-.03 0-.06.003-.089z"/></svg>`
};
